import { createFormHook } from "@tanstack/react-form";

import { FormComponents, FieldComponents } from "@/components/form";
import {
	fieldContext,
	formContext,
} from "@bidbattles/bloks/hooks/form-context";

export const { useAppForm, withForm } = createFormHook({
	fieldComponents: FieldComponents,
	formComponents: FormComponents,
	fieldContext,
	formContext,
});
